import React, { useState, useEffect } from 'react';
import { Link , withRouter, RouteComponentProps } from 'react-router-dom';
import MaterialTable, { MaterialTableProps } from 'material-table';
import {
  Button,
  Grid,
  CircularProgress,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Breadcrumbs
} from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';

import AdminLayout from '../../../../../../../layouts/AdminLayout';
import Spec from '../../../../../../../models/Spec';
import CourseWork from '../../../../../../../models/CourseWork';
import useSnackbar from '../../../../../../../hooks/useSnackbar';
import { useDialog } from '../../../../../../../context/Dialog';
import Course from '../../../../../../../models/Course';
import { ClassroomResourceLink } from '../../../../../../../components/Links';
import { TitleHeader } from '../../../../../../../components/Headers';
import utils from '../../../../../../../libs/utils';

const Specs = (
  props: RouteComponentProps<{
    course_id: string;
    assignment_id: string;
  }>
) => {
  const {
    assignment_id: courseWorkId,
    course_id: courseId
  } = props.match.params;
  const [specs, setSpecs] = useState<Spec[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [course, setCourse] = useState<Course|null>(null);
  const [courseWork, setCourseWork] = useState<CourseWork | null>(null);
  const [courseWorkSpecs, setCourseWorkSpecs] = useState<Spec[]>([]);
  const [specIdsOnProcess, setSpecIdsOnProcess] = useState<string[]>([]);

  const dialog = useDialog();

  const {renderSnackbar, showMessage} = useSnackbar();

  const unAssignedSpecTableOptions: MaterialTableProps<Spec> = {
    title: (<Typography variant="h6">Unassigned</Typography>),
    data: specs.filter(spec => courseWorkSpecs.map(spec => spec.id).indexOf(spec.id) < 0),
    isLoading,
    columns: [
      {
        title: 'Name',
        field: 'name',
        cellStyle: {
          width: '75%'
        }
      },
      {
        title: '',
        sorting: false,
        headerStyle: { textAlign: 'center' },
        cellStyle: { textAlign: 'center' },
        render: (spec) => (
          <div className="text-right">
            <Button
              type="button"
              color="primary"
              variant="contained"
              size="small"
              disabled={specIdsOnProcess.indexOf(spec.id) >= 0}
              endIcon={specIdsOnProcess.indexOf(spec.id) >= 0 ? (<CircularProgress color="inherit" size={12} />) : (<ArrowForward />)}
              onClick={() => assignSpec(spec)}>
              Assign
            </Button>
          </div>
        ),
      },
    ],
    localization: {
      body: {
        emptyDataSourceMessage: 'No Spec/s Found.',
      }
    },
    options: {
      headerStyle: {
        fontWeight: 'bold',
      },
      pageSize: 10,
      pageSizeOptions: [5, 10, 20, 50],
      emptyRowsWhenPaging: false,
      search: true,
      sorting: true,
      draggable: false,
      showEmptyDataSourceMessage: !isLoading,
      thirdSortClick: false
    },
    style: {
      height: '100%'
    }
  };

  const handleDragEnd = (result: DropResult) => {
    if (result.destination !== undefined && result.destination !== null) {
      const newCourseWorkSpecs: Spec[] = [...courseWorkSpecs];
      const [removed] = newCourseWorkSpecs.splice(result.source.index, 1);
      newCourseWorkSpecs.splice(result.destination.index, 0, removed);

      (async () => await setSpecOrder(newCourseWorkSpecs.map((spec, index) => {
        spec.assignmentOrderIndex = index;
        return spec;
      })))();
    }
  };

  const assignSpec = async (spec: Spec) => {
    try {
      if (true || courseWork) {
        setSpecIdsOnProcess([...specIdsOnProcess, spec.id]);
console.log('courseWorkId', courseWorkId);
console.log('spec.id:', spec.id);
        await CourseWork.addSpec(courseWorkId, spec.id);
        await loadCourseWorkSpecs();
        showMessage(`${spec.name} Assigned!`, 'success');
      }
    }
    catch (e) {
      showMessage(`Assign Error: ${e.message}`, 'error');
    }
    finally {
      setSpecIdsOnProcess(specIdsOnProcess.filter(a => a !== spec.id));
    }
  };

  const unAssignSpec = async (spec: Spec) => {
    try {
      const confirm = await dialog.confirm(`Are you sure to remove ${spec.name} from assigned specs?`,{
        cancelText: 'No',
        confirmText: 'Yes'
      });
      if (!confirm)
        return;

      setSpecIdsOnProcess([...specIdsOnProcess, spec.id]);
      await CourseWork.removeSpec(courseWorkId,spec.id);
      await loadCourseWorkSpecs();
      showMessage(`${spec.name} Removed.`, 'success');
    }
    catch (e) {
      showMessage(`Remove Error: ${e.message}`, 'error');
    }
    finally {
      setSpecIdsOnProcess(specIdsOnProcess.filter(a => a !== spec.id));
    }
  };

  const setSpecOrder = async (newAssignedSpecs: Spec[]) => {
    try {
      if (!courseWork) return;

      setCourseWorkSpecs(newAssignedSpecs);
      await courseWork.setSpecs(newAssignedSpecs.map(spec => spec.id));
      showMessage('Spec order has been saved.', 'success');
    }
    catch (e) {
      showMessage(`Error updating spec order: ${e.message}`, 'error');
    }
  };

  const loadSpecs = async () => {
    const result = await Spec.fetchList();
    result.sort((a: Spec, b: Spec) => {
      if (a.name > b.name)
        return 1;
      if (a.name < b.name)
        return -1;
      return 0;
    });
    setSpecs(result);
  };

  const loadCourseWorkSpecs = async () => {
    console.log('loadCourseWorkSpecs test', courseWorkId);
    const data = await Spec.find({
      assignmentID: courseWorkId
    });
    console.log('data fetch test', data);
    setCourseWorkSpecs(data);
  };

  // const loadCourseWork = async () => {
  //   setCourseWork(null);
  //   setCourseWork(await CourseWork.findOne({
  //     id: courseWorkId,
  //     courseId: courseId
  //   }));
  // };

  const loadCourse = async () => {
    const data = await Course.findById({
      courseId
    }); console.log(data, 'data');
    setCourse(await Course.findById({
      courseId
    }));
    
  };

  const loadAllData = async () => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      await Promise.all([
        loadSpecs(),
        loadCourse(),
        // loadCourseWork(),
        loadCourseWorkSpecs()
      ]);
    } catch (e) {
      setErrorMessage(utils.getRequestErrorMessage(e));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => await loadAllData())();
  }, []);

  return (
    <AdminLayout>

      { renderSnackbar() }

      <div className="p-4">
        <div className="pb-4">
          <TitleHeader
            breadcrumb={
              <Breadcrumbs aria-label="breadcrumb">
                <Link to={Course.getListUrlPath('admin')}>Courses</Link>
                <Typography>{course?.fullname || courseId}</Typography>
                <Link to={CourseWork.getListUrlPath(courseId, 'admin')}>Assignments</Link>
                <Typography>{courseWork?.name || courseWorkId}</Typography>
                <Typography>Assign Specs</Typography>
              </Breadcrumbs>
            }
          >
            <Typography variant="h5">
              <span>{ courseWork?.title || courseWorkId } Specs </span>
              {!!courseWork && (<ClassroomResourceLink resource={courseWork} />)}
            </Typography>
          </TitleHeader>
        </div>

        {(() => {

          if (errorMessage)
            return (
              <div className="p-5 text-center">
                <Typography variant="h6">Something went wrong.</Typography>
                <p>{ errorMessage }</p>
                <Button
                  type="button"
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={() => loadAllData()}>
                  Try Again
                </Button>
              </div>
            );

          return (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <MaterialTable {...unAssignedSpecTableOptions} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper className="h-100 d-flex flex-column">
                  <div className="w-100 flex-fill">
                    <div className="MuiToolbar-root MuiToolbar-regular MTableToolbar-root-443 MuiToolbar-gutters">
                      <div className="MTableToolbar-title-447">
                        <Typography variant="h6">Assigned</Typography>
                      </div>
                    </div>

                    {(() => {
                      if (!courseWorkSpecs.length)
                        return (
                          <div className="p-3 text-center">
                            <p>No assigned spec/s.</p>
                          </div>
                        );

                      return (
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{/*getListStyle(snapshot.isDraggingOver)*/}}>
                                <List>
                                  {courseWorkSpecs.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                      {(provided, snapshot) => (
                                        <ListItem
                                          divider={true}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={provided.draggableProps.style}>

                                          <ListItemText>
                                            <Link to={`/admin/specs/${item.id}`} target="_blank">
                                              {item.name}
                                            </Link>
                                          </ListItemText>

                                          <Button
                                            type="button"
                                            color="primary"
                                            variant="outlined"
                                            size="small"
                                            disabled={specIdsOnProcess.indexOf(item.id) >= 0}
                                            endIcon={specIdsOnProcess.indexOf(item.id) >= 0 ? (<CircularProgress color="inherit" size={12} />) : undefined}
                                            onClick={() => unAssignSpec(item)}>
                                            Remove
                                          </Button>
                                        </ListItem>
                                      )}
                                    </Draggable>
                                  ))}
                                </List>
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      );
                    })()}
                  </div>
                  <p className="p-3 text-right">Drag to reorder assigned items.</p>
                </Paper>
              </Grid>
            </Grid>
          );
        })()}
      </div>
    </AdminLayout>
  );
};

export default withRouter(Specs);
